import type {
  AnimationProperties,
  AnimationDefinition,
  AnimationsDefinitions,
} from '../types';
/**
 * Animation properties, (like threshold, hideOnStart etc.)
 * Properties are by animation name, so we assume the properties on the default animation are correct
 * and collect from other view modes only those who doesn't have defaults
 */
function getAllAnimationProperties({
  defaults = {},
  mobile = {},
}: Partial<AnimationsDefinitions>): {
  [key: AnimationDefinition['name']]: Partial<AnimationProperties>;
} {
  const defaultProperties = Object.values(defaults).reduce(
    (
      acc: { [key: AnimationDefinition['name']]: Partial<AnimationProperties> },
      animationDef,
    ) => {
      acc[animationDef.name] = animationDef.properties;
      return acc;
    },
    {},
  );

  const restOfDefs = [...Object.values(mobile)];

  return restOfDefs.reduce(
    (
      acc: { [key: AnimationDefinition['name']]: Partial<AnimationProperties> },
      animationDef,
    ) => {
      if (!acc[animationDef.name]) {
        acc[animationDef.name] = animationDef.properties;
      }
      return acc;
    },
    defaultProperties,
  );
}

/**
 * Normalize view mode to lower case, and default to internal 'defaults' for 'desktop' viewMode
 * We need this to deal with Santa getViewMode()
 */
function getAnimationMode(viewMode = ''): keyof AnimationsDefinitions {
  const normalizedViewMode = viewMode.toLowerCase();
  return normalizedViewMode !== 'desktop'
    ? (normalizedViewMode as keyof AnimationsDefinitions)
    : 'defaults';
}

export { getAllAnimationProperties, getAnimationMode };
